import { z } from "zod";

// `pack` = N≥2 episodes purchased together (Stripe enforces a ฿10 THB minimum
// charge, so single-episode purchases below ฿10 aren't possible — the v1
// product decision is to offer 2-, 3-, or 4-episode packs at the same per-
// episode unit price). `bundle` is the whole-series unlock.
export const purchaseKindSchema = z.enum(["pack", "bundle"]);
export type PurchaseKind = z.infer<typeof purchaseKindSchema>;

export const paymentProviderSchema = z.enum(["stripe", "omise"]);
export type PaymentProviderName = z.infer<typeof paymentProviderSchema>;

export const paymentMethodSchema = z.enum(["card", "promptpay"]);
export type PaymentMethod = z.infer<typeof paymentMethodSchema>;

export const purchaseStatusSchema = z.enum(["pending", "paid", "failed", "refunded", "expired"]);
export type PurchaseStatus = z.infer<typeof purchaseStatusSchema>;

export const purchaseSchema = z.object({
  _id: z.string(),
  userId: z.string(),
  kind: purchaseKindSchema,
  seriesId: z.string(),
  episodeIds: z.array(z.string()).optional(), // pack: 2+ items
  amountThb: z.number().nonnegative(),
  currency: z.literal("THB"),
  paymentProvider: paymentProviderSchema,
  providerSessionId: z.string(),
  providerChargeId: z.string().optional(),
  providerCustomerId: z.string().optional(),
  paymentMethod: paymentMethodSchema.optional(),
  status: purchaseStatusSchema,
  paidAt: z.coerce.date().optional(),
  failedAt: z.coerce.date().optional(),
  refundedAt: z.coerce.date().optional(),
  receiptPdfUrl: z.string().optional(),
  receiptEmailedAt: z.coerce.date().optional(),
  ipHash: z.string().optional(),
  userAgent: z.string().optional(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type Purchase = z.infer<typeof purchaseSchema>;
